import { ABTestInfo, SavedElement } from '../types'

import { useNotificationEvent } from '../composition/useNotificationEvent'
import i18n from '../locales'
import { useRoute, useRouter } from 'vue-router'
import { EMAIL_PREVIEW_ROUTES_NAMES } from 'common/utils/const_helper'
import { reactive } from 'vue'
import { useDateFormat } from '../composable/filters'
import { useRoute, useRouter } from 'vue-router'
import { EMAIL_PREVIEW_ROUTES_NAMES } from 'common/utils/const_helper'
import { appState } from './appState'
import { CustomFont } from '@/src/types'
interface UndoRedoEvents {
  historyQueueLength: number
  historyPosition: number
}

export const builderState = reactive({
  loader: false,
  saveAsTemplateLoading: false,
  lastSavedOn: '',
  saveStatus: 'No unsaved changes',
  unsavedChanges: false,
  historyQueueLength: 0,
  historyPosition: -1,
  hasRSSElement: false,
  previewUrl: '',
  updatedAt: '',
  ABTestCampaignInfo: {} as ABTestInfo,
  updatedABTest: false,
  subjectLine: '',
  fromAddress: '',
  errorState: false,
  mediaOpen: false,
  contentAiIds: {} as any,
  currentAiEditor: '',
  contentUpdated: true,
  enableContentAI: false,
  bulkReqInfo: {} as any,
  isNewBuilder: false,
  attachments: [],
  logoUrl: '',
  openLayoutTemplates: false,
  savedElements: { updated: false } as {
    elements: Array<SavedElement>
    totalCount: number
    updated: boolean
  },
  customValues: [],
  currencySymbols: {} as any,
  currency: 'USD',
  currentImageSlide: 0,
  loadedFonts: [] as Array<string>,
  customFonts: [] as Array<CustomFont>,
  selectedFonts: [] as Array<string>,
  importerData: null,
  emailStatus: '',
})

export const useBuilder = store => {
  const router = useRouter()
  const route = useRoute()
  const { enableNotification } = useNotificationEvent()

  const { dateNow } = useDateFormat()
  function saveEditor(
    isTemplate = true,
    saveAsNewTemplate = false,
    templateName = ''
  ) {
    if (saveAsNewTemplate) builderState.saveAsTemplateLoading = true
    else builderState.loader = true
    builderState.saveStatus = 'Saving..'
    if (store.state.builderState) {
      //@ts-ignore
      store.state.builderState.then(child => {
        if (saveAsNewTemplate) {
          child.call('clone-template', templateName)
          appState.templateName = templateName
        } else child.get('save-template').then(async (eventLog: any) => {})

        child.on('template-saving-status', (status: any) => {
          const { status: success, previewUrl, clonedTemplateId } = status
          if (saveAsNewTemplate && clonedTemplateId) {
            const routeOptions = {
              name: EMAIL_PREVIEW_ROUTES_NAMES.EMAIL_TEMPLATE_BUILDER,
              params: { email_id: clonedTemplateId },
            } as any
            appState.templateId = clonedTemplateId
            // if (route.query) routeOptions.query = route.query
            // router.replace(routeOptions)
          }
          builderState.loader = false
          builderState.saveAsTemplateLoading = false
          //Adding last save time will force UI re-rendering if some component is dependent on this URL
          builderState.previewUrl = `${previewUrl}&lastSavedOn=${new Date().getTime()}`
          builderState.saveStatus = success
            ? `(${i18n.global.t('common.lastSave', {
                date: builderState.lastSavedOn,
              })})`
            : i18n.global.t('common.unsavedChanges')
          if (success) {
            builderState.unsavedChanges = false
            builderState.lastSavedOn = dateNow('hh:mm A')
            builderState.updatedAt = dateNow('MMM DD, YYYY hh:mm a')
            enableNotification({
              title: `${i18n.global.t('common.saved')!}`,
              content: i18n.global.t(
                isTemplate
                  ? 'emailTemplate.templateSaved'
                  : 'emailCampaign.campaignSaved'
              ),
              type: 'success',
            })
          } else {
            enableNotification({
              title: `${i18n.global.t('emailCampaign.error')}!`,
              content: i18n.global.t(
                isTemplate
                  ? 'emailTemplate.templateSavedFail'
                  : 'emailCampaign.campaignSavedFail'
              ),
              type: 'error',
            })
          }
          return
        })
        // update ab info after save
        child.call('get-ab-campaign-info', '')
        child.on('update-ab-campaign-info', async (data: ABTestInfo) => {
          builderState.ABTestCampaignInfo = data
        })
      })
    }
  }
  function updateUnsavedChanges() {
    builderState.saveStatus = `Unsaved changes`
    builderState.unsavedChanges = true
  }
  function updateUndoRedoEvents({
    historyQueueLength,
    historyPosition,
  }: UndoRedoEvents) {
    builderState.historyQueueLength = historyQueueLength
    builderState.historyPosition = historyPosition
  }

  return {
    saveEditor,
    updateUnsavedChanges,
    updateUndoRedoEvents,
  }
}
